import { render } from "./calendarForEvent.vue?vue&type=template&id=affc3e92&scoped=true"
import script from "./calendarForEvent.vue?vue&type=script&lang=js"
export * from "./calendarForEvent.vue?vue&type=script&lang=js"

import "./calendarForEvent.vue?vue&type=style&index=0&id=affc3e92&lang=scss&scoped=true"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-affc3e92"]])

export default __exports__